// Lingua dell'area clienti: italiano (it) o cinese semplificato (zh).
// tr('testo italiano', {var}) → testo nella lingua scelta (se manca la traduzione resta l'italiano).
// tz(oggetto, 'campo') → campo_zh scritto/tradotto nel CRM, se c'è e la lingua è il cinese.
// trServer(messaggio) → messaggi d'errore che arrivano dal server.
const CHIAVE = 'jv_area_clienti_lingua';
let LINGUA = 'it';

export function linguaIniziale() {
  try {
    const salvata = localStorage.getItem(CHIAVE);
    if (salvata === 'it' || salvata === 'zh') return salvata;
  } catch (_) { /* privato */ }
  const l = (typeof navigator !== 'undefined' && (navigator.languages?.[0] || navigator.language)) || '';
  return l.toLowerCase().startsWith('zh') ? 'zh' : 'it';
}
export const lingua = () => LINGUA;
export function impostaLingua(l, salva = true) {
  LINGUA = l === 'zh' ? 'zh' : 'it';
  if (typeof document !== 'undefined') document.documentElement.lang = LINGUA === 'zh' ? 'zh-CN' : 'it';
  if (salva) { try { localStorage.setItem(CHIAVE, LINGUA); } catch (_) { /* privato */ } }
}

const ZH = {
  "L'app non risponde": '应用没有响应',
  'Si è verificato un errore, riprova': '出现错误，请重试',
  'Impronta annullata. Riprova o entra con il codice.': '指纹验证已取消。请重试或用验证码登录。',
  'Accesso non riuscito': '登录失败',
  Bentornato: '欢迎回来',
  'Entra con impronta o Face ID': '用指纹或面容 ID 登录',
  "Entra nell'area clienti": '登录客户专区',
  'Ricevi un codice di accesso: niente password da ricordare. Se sei già nostro cliente vedrai anche le tue pratiche.': '获取登录验证码，无需记密码。如果您已是我们的客户，还能看到您的办理事项。',
  'Il tuo cellulare (se sei cliente, quello lasciato allo studio)': '您的手机号（客户请填写留给事务所的号码）',
  'La tua email (se sei cliente, quella lasciata allo studio)': '您的电子邮箱（客户请填写留给事务所的邮箱）',
  'Ricevi il codice': '获取验证码',
  'Inserisci il codice che ti ha dato lo studio.': '请输入事务所给您的验证码。',
  'Ho già un codice dallo studio': '我已有事务所给的验证码',
  Indietro: '返回',
  'Inserisci il codice': '输入验证码',
  Entra: '登录',
  'I tuoi dati restano sui server di JV Service.': '您的数据保存在 JV Service 的服务器上。',
  'Via SMS': '短信',
  'Via email': '电子邮件',
  Promemoria: '提醒',
  'Già fatto, non avvisarmi più': '已办好，不用再提醒',
  'Documento non disponibile': '文件暂不可用',
  Scarica: '下载',
  Condividi: '分享',
  'No grazie': '不用了',
  'Puoi cambiare idea quando vuoi da ⚙ Impostazioni → Privacy e consensi.': '您随时可以在 ⚙ 设置 → 隐私与同意 中更改。',
  'Appuntamento confermato: {quando}. Ti abbiamo mandato la conferma.': '预约已确认：{quando}。确认信息已发送给您。',
  "Annullare l'appuntamento {tipo} di {quando}?": '要取消 {quando} 的 {tipo} 预约吗？',
  "Prenota l'appuntamento {tipo}": '预约 {tipo}',
  'Appuntamenti ISEE e 730': 'ISEE 和 730 预约',
  'Prenota quando vuoi: è confermato subito': '随时预约，立即确认',
  Annulla: '取消',
  'Per prenotare devi essere già nostro cliente: scrivici da Messaggi o chiamaci.': '只有我们的客户才能预约：请在“消息”中留言或给我们打电话。',
  'Prenota {tipo}': '预约 {tipo}',
  'Nessun orario libero nei prossimi giorni: chiamaci o scrivici da Messaggi.': '最近几天没有空闲时间：请打电话或在“消息”中留言。',
  'Conferma appuntamento': '确认预约',
  Notifiche: '通知',
  'Nessuna notifica.': '没有通知。',
  Documenti: '文件',
  'I documenti saranno disponibili quando la pratica è completata.': '事项办完后即可查看文件。',
  'Le tue pratiche': '我的办理事项',
  pratica: '项事务',
  pratiche: '项事务',
  'più recente': '最新',
  'Benvenuto!': '欢迎！',
  'Con questo cellulare o email non risultano ancora pratiche presso JV Service. Puoi leggere i nostri servizi e scriverci da Messaggi. Se sei già nostro cliente, chiedi allo studio di registrare questo contatto: vedrai qui le tue pratiche.':
    '用这个手机号或邮箱在 JV Service 还没有办理事项。您可以浏览我们的服务，并在“消息”中给我们留言。如果您已是我们的客户，请让事务所登记这个联系方式，之后就能在这里看到您的事项。',
  'Per ora non ci sono pratiche da mostrare.': '暂时没有可显示的事项。',
  ultima: '最近',
  News: '新闻',
  '· archivio': '· 存档',
  'Ti interessa questo servizio? Contatta JV Service o passa in ufficio: ti aiutiamo noi.': '对这项服务感兴趣？请联系 JV Service 或来办公室，我们来帮您。',
  'Novità dallo studio': '事务所动态',
  Tutte: '全部',
  'Nessuna news per questo servizio.': '这项服务暂无新闻。',
  'Nessuna news al momento.': '暂时没有新闻。',
  '← scorri col dito per cambiare categoria →': '← 左右滑动切换类别 →',
  NUOVA: '新',
  'In evidenza': '置顶',
  Leggi: '阅读',
  'Nascondi le news scadute': '隐藏过期新闻',
  'Archivio: news scadute': '存档：过期新闻',
  'Nessuna news scaduta.': '没有过期新闻。',
  '{n} nuove questa settimana': '本周 {n} 条新消息',
  '1 nuova questa settimana': '本周 1 条新消息',
  'Bonus, scadenze e aggiornamenti': '补贴、截止日期和最新消息',
  'Nuova richiesta allo studio': '给事务所发新问题',
  'Di cosa ci vuoi scrivere?': '您想咨询什么？',
  'Altro…': '其他…',
  "Scrivi l'argomento (es. Cambio residenza)": '写下主题（例如：更改住址）',
  'Scrivi la tua domanda…': '写下您的问题…',
  'Invia allo studio': '发送给事务所',
  'Scrivi allo studio': '给事务所留言',
  'Una domanda su una pratica o un servizio': '关于办理事项或服务的问题',
  'Le tue richieste': '我的问题',
  'Nome e cognome': '姓名',
  'Rispondi…': '回复…',
  'documenti da portare': '份需携带的文件',
  'Tutti i servizi': '全部服务',
  ': scegli la tua e guarda cosa portare': '：选择您的事项，查看需要带什么',
  'Cerca (es. rinnovo, coesione…)': '搜索（例如：续签、家庭团聚…）',
  "L'elenco delle pratiche di questo servizio sarà disponibile a breve.": '这项服务的办理清单即将推出。',
  'Intanto scrivici o chiamaci: ti diciamo noi cosa serve.': '您可以先给我们留言或打电话，我们会告诉您需要什么。',
  'Entra e scrivi allo studio': '登录后给事务所留言',
  'Nessuna pratica trovata.': '没有找到相关事项。',
  'Documenti da portare': '需携带的文件',
  'Tutto pronto ✓': '全部备齐 ✓',
  '{fatti} di {totale} pronti': '已备 {fatti}/{totale}',
  "Tocca un documento quando ce l'hai: resta segnato su questo telefono.": '备好一份文件就点一下：会保存在这部手机上。',
  'Solo se ricorre il caso': '仅在适用时',
  'Porta gli originali: le copie le facciamo noi. In caso di dubbio scrivici prima di venire.': '请携带原件，复印由我们来做。如有疑问，来之前先给我们留言。',
  'Togli tutte le spunte': '清除所有勾选',
  "Entra e prenota l'appuntamento": '登录并预约',
  'Chiedi informazioni allo studio': '向事务所咨询',
  'I nostri servizi': '我们的服务',
  'Di cosa hai bisogno? (es. rinnovo permesso)': '您需要什么？（例如：续签居留）',
  'Nessuna pratica trovata: scrivici da Messaggi.': '没有找到相关事项：请在“消息”中留言。',
  'Contatta lo studio': '联系事务所',
  'Siamo a disposizione per ogni pratica.': '各类事项，我们随时为您服务。',
  obbligatorio: '必选',
  'Torna ai consensi': '返回同意选项',
  'Ho letto': '我已阅读',
  'La tua privacy': '您的隐私',
  'Prima di continuare, scegli come trattiamo i tuoi dati': '继续之前，请选择我们如何处理您的数据',
  'JV Service tratta i tuoi dati solo per i servizi che ci chiedi, sui propri server in Italia, senza cederli a nessuno.': 'JV Service 只为您委托的服务处理您的数据，数据保存在意大利自有服务器上，不会提供给任何人。',
  "Leggi l'informativa completa": '阅读完整的隐私说明',
  facoltativo: '可选',
  'Puoi cambiare i consensi facoltativi quando vuoi da ⚙ Impostazioni → Privacy e consensi.': '可选同意随时可在 ⚙ 设置 → 隐私与同意 中更改。',
  'Solo obbligatori': '仅必选项',
  'Conferma scelte': '确认选择',
  'Privacy e consensi': '隐私与同意',
  'Sei entrato con': '您的登录方式：',
  ' (non ancora cliente)': '（还不是客户）',
  'Accettata il {data}': '已于 {data} 同意',
  'Chiudi informativa': '关闭隐私说明',
  "Leggi l'informativa privacy": '阅读隐私说明',
  'Per cancellare i tuoi dati o esercitare gli altri diritti scrivi allo studio da Messaggi.': '如需删除您的数据或行使其他权利，请在“消息”中告诉事务所。',
  'Annullato. Puoi riprovare quando vuoi da ⚙ Impostazioni.': '已取消。您随时可以在 ⚙ 设置 中重试。',
  'Attivazione non riuscita': '开启失败',
  'La prossima volta su questo telefono entri con il dito o il volto, senza aspettare il codice.': '下次在这部手机上用指纹或面容登录，无需等待验证码。',
  'Non ora': '以后再说',
  Attiva: '开启',
  'Annullato.': '已取消。',
  'Impronta o Face ID': '指纹或面容 ID',
  'Attiva su questo telefono: entri senza codice.': '已在这部手机上开启：无需验证码即可登录。',
  'Entra con il dito o il volto invece del codice.': '用指纹或面容代替验证码登录。',
  'Attiva su questo telefono': '在这部手机上开启',
  'Su questo dispositivo non è disponibile (serve un telefono con impronta o Face ID, da clienti.crm-jv.com).': '这台设备不支持（需要带指纹或面容 ID 的手机，并通过 clienti.crm-jv.com 使用）。',
  'Attivata il {data}': '开启于 {data}',
  'usata il {data}': '使用于 {data}',
  'Telefono perso o cambiato? Togli qui il vecchio, oppure chiedi allo studio.': '手机丢失或更换了？在这里删除旧手机，或联系事务所。',
  Impostazioni: '设置',
  'Dimensione del testo': '文字大小',
  Aa: 'Aa',
  "Vale per tutta l'app e resta salvata su questo telefono.": '对整个应用生效，并保存在这部手机上。',
  'Entra nell\'area clienti per gestire impronta / Face ID e i consensi privacy.': '登录客户专区后可管理指纹 / 面容 ID 和隐私同意。',
  'Area clienti': '客户专区',
  'Informazioni su {servizio}': '关于 {servizio} 的咨询',
  'Torna ai servizi': '返回服务',
  Servizi: '服务',
  Contatti: '联系',
  Pratiche: '事项',
  Messaggi: '消息',
  'Vuoi che ti avvisiamo delle scadenze?': '需要我们提醒您办理期限吗？',
  'Attiva promemoria': '开启提醒',
  'Ora i promemoria sono spenti: non ti ricorderemo, per esempio, di rinnovare il Canone RAI entro il 31 gennaio.': '提醒目前已关闭：例如，我们不会提醒您在 1 月 31 日前续办 Canone RAI。',
  'Vuoi sapere subito di bonus e nuove scadenze?': '想第一时间了解补贴和新的截止日期吗？',
  'Attiva le novità': '开启新消息',
  "Ora le novità sono spente: non ti avviseremo di bonus, agevolazioni e nuove scadenze di legge. Potrai solo leggerle nell'app.": '新消息目前已关闭：我们不会通知您补贴、优惠和新的法定期限，您只能在应用中自行查看。',
  'Informativa privacy e dati per il servizio': '隐私说明及服务所需数据',
  "Ho letto l'informativa. I dati servono per entrare, vedere le pratiche e scrivere allo studio.": '我已阅读隐私说明。这些数据用于登录、查看事项和联系事务所。',
  'News e novità sui servizi': '服务新闻与动态',
  "Ti avvisiamo di bonus, agevolazioni e nuove scadenze di legge (in app, email o SMS). Senza, non riceverai queste novità: potrai solo leggerle nell'app.": '我们会通知您补贴、优惠和新的法定期限（应用内、电子邮件或短信）。不同意则收不到这些消息，只能在应用中自行查看。',
  'Promemoria delle scadenze': '期限提醒',
  'Ti ricordiamo in tempo le scadenze delle tue pratiche, per esempio il rinnovo del Canone RAI entro il 31 gennaio. Senza, nessun avviso: dovrai ricordartelo tu.': '我们会及时提醒您事项的期限，例如 1 月 31 日前续办 Canone RAI。不同意则不会提醒，需要您自己记住。',
  Piccolo: '小',
  Normale: '标准',
  Grande: '大',
  'Molto grande': '特大',
  'Messaggi con lo studio': '与事务所的消息',
  Aperta: '待处理',
  'In lavorazione': '处理中',
  Chiusa: '已完成',
  Lingua: '语言',
  'Entra e prenota': '登录并预约',
  'Prenota quando vuoi': '随时预约',
  Annunci: '广告', Immobili: '房屋', Lavoro: '工作', 'I miei': '我的', Affitto: '出租', Vendita: '出售',
  'Offro lavoro': '招聘', 'Cerco lavoro': '求职', Stanza: '单间', 'Posto letto': '床位', Appartamento: '公寓', Casa: '独栋房屋',
  'Confezione / tessile': '服装 / 纺织', Ristorazione: '餐饮', Pulizie: '清洁', Edilizia: '建筑', 'Magazzino / logistica': '仓库 / 物流',
  'Colf / badante': '家政 / 护工', 'Negozio / vendita': '商店 / 销售', Altro: '其他', 'Tempo pieno': '全职', 'Part-time': '兼职',
  Stagionale: '季节工', '/mese': '/月', 'Tutti i comuni': '所有城市', 'Prezzo max €': '最高价格 €', 'Nessun annuncio per ora': '暂时没有广告',
  'Mostra altri': '显示更多', 'Segnala annuncio': '举报广告', 'Truffa o richiesta di soldi': '诈骗或要钱', Discriminazione: '歧视',
  'Contenuto offensivo': '冒犯性内容', 'Non più disponibile': '已不可用', 'Spiega cosa non va (facoltativo)': '说明问题（可选）',
  'Invia segnalazione': '提交举报', "Grazie: lo studio controllerà l'annuncio.": '谢谢：事务所会检查这条广告。', Chiama: '打电话',
  copiato: '已复制', Arredato: '带家具', 'Non arredato': '不带家具', 'Spese incluse': '包含杂费', 'Disponibile dal': '可入住日期',
  'Annuncio pubblicato da un privato. JV Service non è intermediario e non è parte di alcun accordo tra le parti.':
    '广告由个人发布。JV Service 不是中介，也不是双方任何协议的一方。',
  "Condizioni d'uso degli annunci": '广告使用条款', 'Ho letto e accetto': '我已阅读并同意', 'Nuovo annuncio': '新广告',
  'Modifica annuncio': '修改广告', 'Pubblica come': '以谁的名义发布', punti: '积分', 'Tipo di immobile': '房屋类型', Settore: '行业',
  Orario: '工作时间', Titolo: '标题', Descrizione: '描述', Comune: '城市', 'Zona (senza indirizzo)': '区域（不写详细地址）',
  'Retribuzione (facoltativa)': '薪资（可选）', 'Prezzo €/mese': '价格 €/月', 'Prezzo €': '价格 €', 'Metri quadri': '平方米', Foto: '照片',
  Aggiungi: '添加', 'Solo foto della casa: niente persone, documenti o targhe.': '只拍房子：不要拍人、证件或车牌。',
  Telefono: '电话', 'ID WeChat': '微信号', 'I contatti saranno visibili a tutti, anche a chi non è cliente.': '联系方式所有人都能看到，包括非客户。',
  'Salva e ripubblica': '保存并重新发布', Pubblica: '发布',
  "Prima di andare online l'annuncio viene controllato in automatico (di solito meno di un minuto).": '广告上线前会自动审核（通常不到一分钟）。',
  'Formato foto non supportato': '不支持的照片格式', "Eliminare l'annuncio?": '删除这条广告？', 'I tuoi punti': '你的积分',
  '1 punto = 1 annuncio online per 7 giorni, rinnovo automatico': '1 积分 = 1 条广告上线 7 天，自动续期', Nuovo: '新建',
  'Vuoi pubblicare un annuncio?': '想发布广告吗？', 'Richiesta inviata: lo studio ti contatterà.': '申请已发送：事务所会联系你。',
  'Chiedi allo studio di attivare i punti per gli annunci.': '请联系事务所开通广告积分。', 'Chiedi allo studio': '联系事务所',
  'Rinnovo il': '续期日期', Modifica: '修改', Pausa: '暂停', Riattiva: '恢复', Elimina: '删除', 'In verifica…': '审核中…', Online: '已上线',
  'Non pubblicato': '未发布', 'In controllo dallo studio': '事务所审核中', 'In pausa': '已暂停', 'In pausa: punti finiti': '已暂停：积分用完',
  'Segnalato: in controllo': '被举报：审核中', 'Tolto dallo studio': '已被事务所删除',
  'I miei annunci': '我的广告', 'Foto troppo pesanti: togline qualcuna e riprova': '照片太大：请删掉几张后重试',
  'Da correggere': '需要修改', 'Non pubblicati: leggi il motivo, correggi e ripubblica': '未发布：请阅读原因，修改后重新发布', 'In attesa': '等待中',
  'In controllo automatico o dallo studio': '自动审核中或事务所审核中', 'Tolti dallo studio': '被事务所删除', Correggi: '修改', Tutti: '全部',
  'Tutti gli stati': '全部状态',
  'Inquadra il codice con WeChat per aggiungerci. Dal telefono: fai uno screenshot e aprilo in WeChat → Scansiona → Album.': '用微信扫码添加我们。在手机上：先截图，再打开微信 → 扫一扫 → 相册。',
  'Inquadra il codice con WeChat per aggiungerci. Dal telefono: tocca il codice per ingrandirlo e salvarlo.': '用微信扫码添加我们。在手机上：点击二维码放大并保存。',
  'Salva o condividi il codice': '保存或分享二维码', "Poi apri WeChat → Scansiona → Album e scegli l'immagine salvata.": '然后打开微信 → 扫一扫 → 相册，选择保存的图片。', Ingrandisci: '放大',
  'Blocca inserzionista': '屏蔽发布者', 'Non vedrai più gli annunci di questo inserzionista su questo telefono. Continuare?': '在这部手机上将不再显示该发布者的广告。继续吗？',
  'Per pubblicare o modificare i tuoi annunci usa il sito clienti.crm-jv.com dal browser.': '如需发布或修改广告，请在浏览器中打开 clienti.crm-jv.com。',
};

// Messaggi del server (errori, avvisi) mostrati al cliente
const ZH_SERVER = {
  'Scrivi un indirizzo email valido': '请输入有效的电子邮箱',
  'Scrivi un numero di cellulare italiano valido': '请输入有效的意大利手机号',
  "Troppe richieste: riprova tra un'ora": '请求太多：请一小时后再试',
  'Ti abbiamo inviato un SMS con il codice.': '验证码已通过短信发送给您。',
  'Ti abbiamo inviato il codice per email (guarda anche nello spam).': '验证码已发送到您的邮箱（也请查看垃圾邮件）。',
  "Per entrare devi prendere visione dell'informativa privacy": '登录前请先阅读隐私说明',
  'Codice scaduto: richiedine uno nuovo': '验证码已过期：请重新获取',
  'Codice errato': '验证码错误',
  'Sessione scaduta: accedi di nuovo': '登录已过期：请重新登录',
  'Accesso richiesto': '请先登录',
  'Il telefono che invia gli SMS non risponde': '发送短信的手机没有响应',
  'Invio SMS non riuscito': '短信发送失败',
  "Invio dell'email non riuscito, riprova o scegli l'SMS": '邮件发送失败，请重试或改用短信',
  'Documento non trovato': '找不到文件',
  'Documento non ancora disponibile': '文件暂不可用',
  'Promemoria non trovato': '找不到提醒',
  'Scrivi il messaggio': '请写下内容',
  'Messaggio troppo lungo (massimo 3000 caratteri)': '内容太长（最多 3000 字）',
  'Oggetto: da 3 a 120 caratteri': '主题：3 到 120 个字符',
  'Scrivi nome e cognome': '请填写姓名',
  'Hai già inviato molte richieste oggi: chiama lo studio per le urgenze': '您今天已发送很多问题：紧急情况请打电话给事务所',
  'Richiesta non trovata': '找不到该问题',
  'Conversazione troppo lunga: apri una nuova richiesta': '对话太长：请新建一个问题',
  'Per prenotare devi essere già cliente di JV Service: scrivici o chiamaci': '只有 JV Service 的客户才能预约：请留言或打电话给我们',
  'Tipo non valido': '类型无效',
  'Hai già un appuntamento per questo servizio: annullalo prima di prenotarne un altro': '您已有这项服务的预约：请先取消再预约',
  'Appuntamento non trovato o non più annullabile': '找不到预约或已无法取消',
  'Questo orario è già occupato: scegline un altro': '该时间已被预约：请选择其他时间',
  'Orario fuori dagli orari di apertura': '不在营业时间内',
  'Orario già passato o troppo vicino: scegline un altro': '时间已过或太近：请选择其他时间',
  "La presa visione dell'informativa è necessaria per usare l'area clienti": '使用客户专区必须同意隐私说明',
  'Impronta non più attiva su questo telefono: entra con il codice': '这部手机上的指纹登录已失效：请用验证码登录',
  'Impronta non riconosciuta: entra con il codice': '指纹无法识别：请用验证码登录',
  'Attivazione non riuscita: riprova': '开启失败：请重试',
  'Richiesta scaduta: riprova': '请求已过期：请重试',
  'Troppi dispositivi registrati: togline qualcuno da Impostazioni': '登记的设备太多：请在设置中删除一些',
  'Telefono non più registrato: entra con il codice': '这部手机已不再登记：请用验证码登录',
  'Dispositivo non trovato': '找不到设备',
  'Compila tutti i campi obbligatori': '请填写所有必填项', 'Controlla i numeri inseriti': '请检查填写的数字',
  'Inserisci almeno un contatto (telefono, WhatsApp o WeChat)': '请至少填写一个联系方式（电话、WhatsApp 或微信）',
  'Il prezzo è obbligatorio': '价格是必填项', "Accetta prima le condizioni d'uso degli annunci": '请先同意广告使用条款',
  'Non hai punti: chiedi una ricarica allo studio': '你没有积分：请联系事务所充值', 'Gli annunci di lavoro non hanno foto': '工作广告不能上传照片',
  'Massimo 8 foto': '最多 8 张照片', 'Annuncio non più disponibile': '广告已不可用', 'Scegli il motivo della segnalazione': '请选择举报原因',
  'Per pubblicare annunci serve essere clienti dello studio': '只有事务所的客户才能发布广告',
  'Annuncio segnalato: lo sta controllando lo studio': '广告被举报：事务所正在审核',
  'Annuncio tolto dallo studio: non si può modificare': '广告已被事务所删除：无法修改',
  'Hai raggiunto il numero massimo di annunci': '已达到广告数量上限', 'Troppe segnalazioni, riprova più tardi': '举报次数过多，请稍后再试',
  'Scegli Immobili o Lavoro': '请选择房屋或工作', 'Tipo di annuncio non valido': '广告类型无效', 'Scegli il tipo di immobile': '请选择房屋类型',
  'Scegli il settore': '请选择行业', "Scegli l'orario": '请选择工作时间', 'Dati non validi': '数据无效', 'Persona non valida': '发布人无效',
  'Annuncio non trovato': '找不到广告', 'Si può mettere in pausa solo un annuncio online': '只能暂停已上线的广告',
  "L'annuncio non è in pausa": '广告没有暂停', 'Le condizioni sono state aggiornate: rileggile': '条款已更新：请重新阅读',
  'Foto troppo grande (massimo 10 MB)': '照片太大（最大 10 MB）', 'File non riconosciuto come foto (JPEG o PNG)': '无法识别为照片（JPEG 或 PNG）',
  "L'annuncio è cambiato nel frattempo: ricarica la pagina": '广告已被更改：请刷新页面',
  'Non puoi più pubblicare annunci: contatta lo studio': '你不能再发布广告：请联系事务所', "Dall'app non si possono pubblicare annunci: usa il sito clienti.crm-jv.com": '应用内无法发布广告：请使用网站 clienti.crm-jv.com',
};

export function tr(testo, valori) {
  let out = (LINGUA === 'zh' && (ZH[testo] || ZH_SERVER[testo])) || testo;
  if (valori) Object.entries(valori).forEach(([k, v]) => { out = out.split(`{${k}}`).join(v); });
  return out;
}

export const tz = (oggetto, campo) => (LINGUA === 'zh' && oggetto?.[`${campo}_zh`]) || oggetto?.[campo] || '';

export function trServer(messaggio) {
  if (LINGUA !== 'zh' || !messaggio) return messaggio;
  if (ZH_SERVER[messaggio]) return ZH_SERVER[messaggio];
  let m = messaggio.match(/^Per (.+) si prenota solo nel periodo indicato dallo studio$/);
  if (m) return `${m[1]} 只能在事务所规定的时间段内预约`;
  m = messaggio.match(/^Le prenotazioni (.+) dall'app sono chiuse/);
  if (m) return `${m[1]} 目前不能在应用中预约，请打电话或给我们留言。`;
  return messaggio;
}
